<script>
import { defineComponent } from 'vue'
import PageAthletics from '@v/athleticsFeedComponentFetch.vue'

export default defineComponent({
    components: {
        PageAthletics,
    },
})

</script>